<template>
  <button
    @click.prevent="shareLink"
    :class="['btn-share', `btn-share--${customClass}`]"
    type="button"
  ></button>
</template>

<script>
export default {
  props: {
    customClass: {
      type: String,
      required: true
    }
  },
  methods: {
    shareLink(e) {
      this.$emit('shareLink', { btn: e.target })
    }
  }
}
</script>

<style lang="scss">
.btn-share {
  @include button-reset;

  &--facebook {
    width: 27px;
    height: 28px;
    background: url('~/static/img/facebook-share.svg') no-repeat center;
    background-size: cover;
  }

  &--telegram {
    width: 30px;
    height: 28px;
    background: url('~/static/img/telegram-share.png') no-repeat center;
    background-size: cover;
  }

  &--google {
    width: 29px;
    height: 28px;
    background: url('~/static/img/google-share.svg') no-repeat center;
    background-size: cover;
  }
}

@include media-min($desktop-width) {
  .btn-share {
    &--facebook {
      width: 31px;
      height: 33px;
    }

    &--telegram {
      width: 35px;
      height: 33px;
    }

    &--google {
      width: 34px;
      height: 31px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseSocialShare.vue